import styleInject from '../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".select-panel {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0px 12px;\n}\n.select-panel .ti-radio-wrap {\n  border-radius: 4px;\n  padding: 10px;\n  background-color: rgba(69, 98, 157, 0.05);\n  margin-bottom: 12px;\n}\n.select-panel .ti-radio-wrap:last-child {\n  margin-bottom: 48px;\n}\n";
styleInject(css_248z);

export { css_248z as default };
